const obsDoc = {
  lineSpacing: 0.25,
  headerSpacing: 1,
  xPosition: 0.5,
  pageWrapInitialYPosition: 0.5,
};

export default obsDoc;
